import { render, staticRenderFns } from "./SettingsPersonalInfo.vue?vue&type=template&id=60c6ee4e&scoped=true&"
import script from "./SettingsPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./SettingsPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPersonalInfo.vue?vue&type=style&index=0&id=60c6ee4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6ee4e",
  null
  
)

export default component.exports